import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';
import { useSettings } from '../hooks/useSettings';
import { Link, useNavigate, useLocation } from 'react-router-dom';


const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { settings } = useSettings();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      // Aguarda o render da home para dar scroll
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      scrollToSection('hero');
    }
  };


  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(companyInfo.whatsappMessage);
    window.open(`https://wa.me/${settings.whatsappPhone}?text=${message}`, '_blank');
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer flex-1 lg:flex-none flex justify-center lg:justify-start" onClick={handleLogoClick}>
            <img
              src="/logo-ponto-a-ponto-v2.png"
              alt="Ponto a Ponto Transportes"
              className="h-16 lg:h-20 w-auto"
            />
          </div>


          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-[#111827] hover:text-[#EAB308] transition-colors duration-200 font-medium"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('como-funciona')}
              className="text-[#111827] hover:text-[#EAB308] transition-colors duration-200 font-medium"
            >
              Como Funciona
            </button>
            <button
              onClick={() => scrollToSection('testemunhos')}
              className="text-[#111827] hover:text-[#EAB308] transition-colors duration-200 font-medium"
            >
              Testemunhos
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-[#111827] hover:text-[#EAB308] transition-colors duration-200 font-medium"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contactos')}
              className="text-[#111827] hover:text-[#EAB308] transition-colors duration-200 font-medium"
            >
              Contactos
            </button>
          </nav>

          {/* CTA Button Desktop */}
          <div className="hidden lg:block">
            <Button
              onClick={handleWhatsAppClick}
              className="bg-[#EAB308] hover:bg-[#CA8A04] text-black font-semibold px-6 py-2.5 rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-[#EAB308]/50"
            >
              <Phone className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-[#111827] p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white/98 backdrop-blur-md border-t border-gray-100 shadow-xl">
          <nav className="px-4 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('servicos')}
              className="block w-full text-left text-[#111827] hover:text-[#EAB308] py-2 transition-colors font-medium"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('como-funciona')}
              className="block w-full text-left text-[#111827] hover:text-[#EAB308] py-2 transition-colors font-medium"
            >
              Como Funciona
            </button>
            <button
              onClick={() => scrollToSection('testemunhos')}
              className="block w-full text-left text-[#111827] hover:text-[#EAB308] py-2 transition-colors font-medium"
            >
              Testemunhos
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-[#111827] hover:text-[#EAB308] py-2 transition-colors font-medium"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('contactos')}
              className="block w-full text-left text-[#111827] hover:text-[#EAB308] py-2 transition-colors font-medium"
            >
              Contactos
            </button>
            <Button
              onClick={handleWhatsAppClick}
              className="w-full bg-[#EAB308] hover:bg-[#CA8A04] text-black font-semibold py-3 mt-4"
            >
              <Phone className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
